import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext.js';
import { Button, Input, Form, Card, message } from 'antd';
import axios from 'axios';

const Login = () => {
  const [credentials, setCredentials] = useState({ user: '', password: '' });
  const { login } = useContext(LoginContext);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/usuarios/login`, {
        user: credentials.user,
        password: credentials.password,
      });

      const { usuario, token } = response.data;

      login({ ...usuario, token }); // Guardar todos los datos del usuario en el contexto

      switch (usuario.tiu_descripcion) {
        case 'Empresa':
          navigate('/home');
          break;
        case 'Sucursal':
          navigate('/home');
          break;
        case 'Cliente':
          navigate('/home');
          break;
        default:
          message.error('Tipo de usuario no reconocido');
      }
    } catch (error) {
      message.error('Credenciales incorrectas');
    }
  };

  return (
    <Card style={{ width: 300, margin: '100px auto' }}>
      {/* Logo */}
      <div style={{ textAlign: 'center' }}>
        <img src="/logosuarez.png" alt="Shop Suarez" style={{ width: '250px' }} />
      </div>
      <Form onFinish={handleSubmit}>
        <Form.Item>
          <Input
            placeholder="Usuario"
            value={credentials.user}
            onChange={(e) => setCredentials({ ...credentials, user: e.target.value })}
          />
        </Form.Item>
        <Form.Item>
          <Input.Password
            placeholder="Contraseña"
            value={credentials.password}
            onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Iniciar sesión
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default Login;
